import { isNumber, isUndefined } from './type';

/**
 * 将其他类型转成 Number
 *
 * @export
 * @param {*} val
 * @param {*} defaultValue
 * @returns {number}
 */
export function cast(val, defaultValue) {
  const result = +val;

  if (isNumber(result)) {
    return result;
  }

  if (!isUndefined(defaultValue)) {
    return defaultValue;
  }

  return result;
}
